import React from "react";
import { useParams, Link } from "react-router-dom";
import Loader from "@components/Loader";
import {
  useOrderQuery,
  useOrderProductsQuery,
  useOrderTotalsQuery,
  useOrderNotesQuery,
  useOrderHistoryQuery,
} from "@queries/order";
import { useCustomerHistoryQuery } from "@queries/customers";
import OrderSummary from "@components/orders/OrderSummary";
import OrderAddresses from "@components/orders/OrderAddresses";
import OrderProducts from "@components/orders/OrderProducts";
import OrderTotals from "@components/orders/OrderTotals";
import OrderNotes from "@components/orders/OrderNotes";
import OrderChecklist from "@components/orders/OrderChecklist";
import OrderServiceTime from "@components/orders/OrderServiceTime";
//import "@styles/admin-theme.css";

export default function OrderInfoPage() {
  const { id } = useParams();
  const orderQ = useOrderQuery(id);
  const prodsQ = useOrderProductsQuery(id);
  const totalsQ = useOrderTotalsQuery(id);
  const notesQ = useOrderNotesQuery(id);
  const histQ = useOrderHistoryQuery(id);

  const loading = orderQ.isLoading || prodsQ.isLoading || totalsQ.isLoading;

  const order = orderQ.data;
  const customerId = order?.customer_id;
  const customerHistoryQ = useCustomerHistoryQuery(customerId);

  if (loading) return <Loader />;
  if (orderQ.isError) return <div className="content"><div className="card">Error: {orderQ.error.message}</div></div>;

  return (
    <div className="content">
      <div className="header">
        <h1>Order #{order?.id ?? id}</h1>
        <nav className="bc">
          <Link to="/orders">Orders</Link> <span className="sep">›</span>
          <span>Order Info</span>
        </nav>
      </div>

      <OrderSummary order={order} />

      <OrderServiceTime order={order} />

      <OrderAddresses order={order} />

      <OrderChecklist orderId={id} />

      <OrderProducts orderId={id} products={prodsQ.data || []} />

      <OrderTotals orderId={id} order={order} totals={totalsQ.data || {}} products={prodsQ.data || []} />

      {customerHistoryQ.data?.data && customerHistoryQ.data.data.filter(h => !h.archived).length > 0 && (
        <div className="card" style={{ marginBottom: "20px" }}>
          <div className="card-header">
            <h2>Customer Special Notes</h2>
          </div>
          <div className="card-body">
            <div style={{ fontSize: "12px", whiteSpace: "pre-line" }}>
              {customerHistoryQ.data.data
                .filter((h) => !h.archived)
                .map((h) => `- ${h.comment}`)
                .join("\n")}
            </div>
          </div>
        </div>
      )}

      <OrderNotes
        orderId={id}
        notes={notesQ.data || []}
        history={histQ.data || []}
      />
    </div>
  );
}

